const FGeneralContent = `

[F.—National Committee for Promotion of Social and Economic Welfare

General

11F. In this sub-part "National Committee" means the National Committee defined in section 35AC.



`;

export default FGeneralContent;